if (!customElements.get('s-filter-modal')) {
  customElements.define('s-filter-modal', class SectionFilterModal extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.isOpen = false;
        this.buttonCloser = this.querySelector(".js-filter-modal__close-modal");
        this.headerWrapper = this.querySelector(".js-filter-modal__header-wrapper");
        this.sortWrapper = this.querySelector(".js-filter-modal__sort-wrapper");
        this.sortForm = this.querySelector(".js-filter-modal__sort-list");
        this.sortItems = Array.from(this.querySelectorAll(".js-filter-modal__sort-item"));

        this.filterList = this.querySelector(".js-filter-modal__filter-list");

        this.filterItems = Array.from(this.querySelectorAll(".js-filter-modal__filter-item"));
        this.filterTabs = Array.from(this.querySelectorAll(".js-filter-modal__filter-tab"));

        this.filterItems.forEach(item => {
          item.addEventListener("click", this.tabsHandler.bind(this, item))
        })

        this.sortForm.addEventListener("change", this.sortChanger)

        this.buttonCloser.addEventListener("click", this.closerHandler)

        this.initVariables()

        subscribe("open-filter-modal", this.modalOpener)
        subscribe("update-filter", this.modalUpdate)
      }

      disconnectedCallback() {
        this.filterItems.forEach(item => {
          item.removeEventListener("click", this.tabsHandler.bind(this, item))
        })

        this.sortForm.removeEventListener("change", this.sortChanger)

        this.buttonCloser.removeEventListener("click", this.closerHandler)

        this.filterInputs.forEach(input => {
          input.removeEventListener("change", this.filterChanger)
        })
      }

      initVariables = () => {
        if (this.filterInputs) {
          this.filterInputs.forEach(input => {
            input.removeEventListener("change", this.filterChanger)
          })
        }
        
        this.filterInputs = Array.from(this.querySelectorAll(".js-filter-modal__filter-value"));

        this.filterInputs.forEach(input => {
          input.addEventListener("change", this.filterChanger)
        })
      }

      modalUpdate = (newDom) => {
        let section = newDom.querySelector("s-filter-modal");

        this.headerWrapper.innerHTML = section.querySelector(".js-filter-modal__header-wrapper").innerHTML;

        let newSortItems = Array.from(section.querySelectorAll(".js-filter-modal__sort-item"))
        this.sortItems.forEach((item, i) => {
          item.innerHTML = newSortItems[i].innerHTML;
        })

        let newFilterTabs = Array.from(section.querySelectorAll(".js-filter-modal__filter-tab"));
        this.filterTabs.forEach((tab, i) => {
          tab.innerHTML = newFilterTabs[i].innerHTML;
        })

        this.initVariables()
      }

      sortChanger = (event) => {
        publish("sort-changer", event)
      }

      filterChanger = (event) => {
        publish("filter-changer", event)
      }

      tabsHandler = (item) => {
        let tab = this.filterTabs.find(tab => tab.dataset.tab == item.dataset.item);

        tab.classList.add("is-open");
        this.filterList.classList.add("is-hide");
        this.sortWrapper.classList.add("is-hide");
        this.isOpen = true;
      }

      closerHandler = () => {
        if (this.isOpen) {
          this.filterTabs.forEach(tab => {
            tab.classList.remove("is-open");
          })
          
          this.filterList.classList.remove("is-hide");
          this.sortWrapper.classList.remove("is-hide");
          this.isOpen = false;
        } else {
          this.classList.remove("is-open")
          document.body.classList.remove('stores-modal-active')
        }
      }

      modalOpener = () => {
        this.filterList.classList.remove("is-hide");
        this.sortWrapper.classList.remove("is-hide");
        this.filterTabs.forEach(tab => {
          tab.classList.remove("is-open");
        })
        this.isOpen = false;

        this.classList.add("is-open");

        document.body.classList.add('stores-modal-active')
      }
    }
  );
}
